<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>company.queues.module-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="vox-inline-message vox-inline-message_light-grey mb-3">
        <div>
          <i class="icon-small-info"></i>
          <span [innerHTML]="'company.queues.module-popup.info' | translate"></span>
        </div>
      </div>
      <form>
        <div class="vox-input-group mb-3">
          <label translate>company.queues.module-popup.label</label>
          <div ngbDropdown class="vox-dropdown-input">
            <button id="queue module" ngbDropdownToggle>
              <span>{{queueModule.value | noUnderscore }}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="queue module">
              <button ngbDropdownItem *ngFor="let m of queueModules" (click)="selectQueueModule(m)" >{{m | noUnderscore}}</button>
            </div>
          </div>
        </div>
        <button class="vox-btn vox-btn-secondary" type="submit" [ladda]="loading" [disabled]="!canSubmit" (click)="saveModule()">
          <span translate>common.save</span>
        </button>
      </form>
    </div>
  </div>
</div>
